import { FC } from 'react';

import useTooltipActions from '@/apps/mwd-v2/state/actions/useTooltipActions';
import useClientState from '@/state/useClientState';

import { SwitchComponent } from '../../../../UI/Switch/Switch';

import styles from './SearchFeatureToggle.module.css';

/**
 * Feature toggle with environment controlled feature flag.
 * @returns
 */
const SearchFeatureToggle: FC = () => {
  const version = useClientState((state) => state.version);
  const toggleVersion = useClientState((state) => (value: boolean) => state.toggleVersion(value ? 2 : 1));
  const { setShowTooltip, hideTooltipWithTimeout } = useTooltipActions();
  const showTooltipEvent = (event: React.MouseEvent<HTMLDivElement>) => {
    setShowTooltip(
      'featureFlagSearchAutocomplete',
      { y: event.clientY, x: event.clientX },
      'Schakel in om de nieuwe manier van zoeken uit te proberen.',
    );
  };
  return (
    <>
      <div
        className={styles.nieuweZoekenDiv}
        onMouseEnter={showTooltipEvent}
        onMouseMove={showTooltipEvent}
        onMouseLeave={() => {
          hideTooltipWithTimeout();
        }}
      >
        <div className={styles.nieuweZoekenLabel}>Nieuwe zoeken&nbsp;</div>
        <div style={{ display: 'flex', cursor: 'pointer', lineHeight: '24px' }}>
          <SwitchComponent
            thinVariant
            data-testid='nieuweZoekenSwitch'
            defaultValue={version === 2}
            onChange={toggleVersion}
          />
        </div>
      </div>
    </>
  );
};
export default SearchFeatureToggle;
